export default {"src":"/_next/static/media/we-money-and-finder.5bacb27d.svg","height":277,"width":286,"blurWidth":0,"blurHeight":0};